export default __webpack_public_path__ + "static/media/close.e47749a8.svg";